import * as React from 'react'

import { Indicator } from '~/atoms/text/Indicator'
import { IndicatorAlerts } from '~/atoms/text/IndicatorAlerts'
import { InformationText } from '~/atoms/text/InformationText'
import { MobileMenu } from '~/atoms/menu/MobileMenu'
import { ChildForm, IProps as IChildForm } from '~/organisms/user/ChildForm'
import {
  ParentSideMenu,
  PAGE_TYPE_PROFILE_EDIT_CHILD,
} from '~/organisms/menu/ParentSideMenu'
import { PAGE_TYPE_PROFILE } from '~/organisms/nav/ParentUserNav'
import { UserBaseLayout } from '~/templates/user/UserBaseLayout'

import * as Style from './style.css'

export interface IProps extends IChildForm {
  user: IUser
  errorMessages?: string[]
  noticeMessage?: string
  alertMessage?: string
  webviwe?: boolean
  isRequesting?: boolean
}

export const ProfileEditChild = ({
  user,
  errorMessages,
  noticeMessage,
  alertMessage,
  webviwe,
  isRequesting,
  ...props
}: IProps): JSX.Element => {
  const [isHidden, setIsHidden] = React.useState(false)
  const handleClick = () => {
    setIsHidden(true)
  }

  return (
    <UserBaseLayout user={user} pageType={PAGE_TYPE_PROFILE}>
      <>
        {!webviwe && (
          <div className={Style.ProfileEditChildMobileMenu}>
            <MobileMenu pageTitle="お子様情報" previousUrl="/users/base" />
          </div>
        )}
        <div className={Style.ProfileEditChildContainer}>
          <div className={Style.ProfileEditChildSideMenu}>
            {!webviwe && (
              <ParentSideMenu pageType={PAGE_TYPE_PROFILE_EDIT_CHILD} />
            )}
          </div>
          <div className={Style.ProfileEditChildMain}>
            {!isHidden && errorMessages && errorMessages.length > 0 && (
              <div className={Style.ProfileEditChildNotice}>
                <IndicatorAlerts
                  texts={errorMessages}
                  clickhandler={handleClick}
                />
              </div>
            )}
            {!isHidden && noticeMessage && (
              <div className={Style.ProfileEditChildNotice}>
                <Indicator
                  text={noticeMessage}
                  color="notice"
                  clickhandler={handleClick}
                />
              </div>
            )}
            {!isHidden && alertMessage && (
              <div className={Style.ProfileEditChildNotice}>
                <Indicator
                  text={alertMessage}
                  color="alert"
                  clickhandler={handleClick}
                />
              </div>
            )}
            <div className={Style.ProfileEditChildTitle}>お子様情報</div>
            <div className={Style.ProfileEditChildRequest}>
              {isRequesting && (
                <InformationText
                  title="現在、お子様情報を申請中です。"
                  color="notice"
                >
                  承認が完了するまで変更できません。
                </InformationText>
              )}
              {!isRequesting && <ChildForm {...props} />}
            </div>
          </div>
        </div>
      </>
    </UserBaseLayout>
  )
}
